import { FlexComp, ImageComponent } from "@tm/static";
import { FormattedText } from "@tm/ui-widgets/components";
import React from "react";
import {
  AdditionalInfo,
  CloseButton,
  Description,
  ImageTitleContainer,
  ModalContainer,
  Title,
} from "./EducationHighlights.style";

interface ModalProps {
  imageUrl: string;
  title: string;
  description: string;
  additionalInfo?: string;
  onClose?: () => void;
  imageWidth?: string;
  imageHeight?: string;
}

interface ModalBackendData {
  pageID?: string;
  data?: {
    image?: {
      url: string;
      height?: string;
      width?: string;
    };
    title?: {
      text: {
        value: string;
        styles?: Record<string, any>;
      };
    };
    subTitle?: {
      text: {
        value: string;
        styles?: Record<string, any>;
      };
    };
    info?: {
      text: {
        value: string;
        styles?: Record<string, any>;
      };
    };
    ctas?: Array<{
      title: {
        text: string;
        styles?: Record<string, any>;
      };
      styles?: {
        bgColors?: string[];
      };
    }>;
  };
}

interface BackendModalProps {
  backendData?: ModalBackendData;
}

type CombinedModalProps = ModalProps | BackendModalProps;

const EducationHighlights: React.FC<CombinedModalProps> = (props) => {
  const { backendData } = props as BackendModalProps;
  const data = backendData?.data;
  const imageUrl = data?.image?.url || "";
  const imageWidth = data?.image?.width ? `${data.image.width}px` : "120px";
  const imageHeight = data?.image?.height ? `${data.image.height}px` : "120px";
  const title = data?.title?.text.value || "";
  const description = data?.subTitle?.text.value || "";
  const additionalInfo = data?.info?.text.value;

  return (
    <ModalContainer>
      <ImageTitleContainer>
      <FlexComp justifyContent="center" alignItems="center" width="100%" height="100%" flexDirection="column">
        <ImageComponent
          src={imageUrl}
          width={imageWidth}
          height={imageHeight}
          alt="Modal illustration"
      />
      <Title>
        <FormattedText value={title} />
      </Title>
      </FlexComp>
      </ImageTitleContainer>
      <Description>
        <FormattedText value={description} />
      </Description>

      {additionalInfo && (
        <AdditionalInfo>
          <FormattedText value={additionalInfo} />
        </AdditionalInfo>
      )}
    </ModalContainer>
  );
};

export default EducationHighlights;
